import { AccountsPermissions } from './accounts.permissions';
import { AccountsSpecializedRolesPermissions } from './accounts-specialized-roles.permissions';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { PermissionEnum } from '../../../common/permissions/permissions.Enum';

export class AccountsSpecializedRolesPermissionsPermissions {
    static GroupName = `${AccountsSpecializedRolesPermissions.GroupName}.Permissions`;

    static getPermissions = getGroupPermissionFactory(AccountsSpecializedRolesPermissionsPermissions.GroupName);

    static Permissions = {
        Assign: AccountsSpecializedRolesPermissionsPermissions.getPermissions('Assign'),
        Revoke: AccountsSpecializedRolesPermissionsPermissions.getPermissions('Revoke'),
        ReadAll: AccountsSpecializedRolesPermissionsPermissions.getPermissions(PermissionEnum.READ_ALL)
    };
}
